import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import "@fontsource-variable/inter";
import "@fontsource/outfit/500.css";
import "@dfws/ui/tokens.css";
import "@dfws/ui/accents.css";
import "@dfws/ui/base.css";
import { router } from "./app/router";
import { queryClient } from "./lib/queries";

const el = document.getElementById("root");
if (!el) throw new Error("root element missing");
createRoot(el).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
